export default __webpack_public_path__ + "static/media/token-logo.552b0ac0.png";